import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardLayoutComponent} from 'src/app/shared/layout/dashboard-layout/component/dashboard-layout.component';
import {accessTokenGuard} from "../../core/guards/access-token.guard";
import {EAccessType} from "../../core/enums/access-type.enum";
import {EAdminPermission} from "../../core/enums/admin-permission.enum";


const routes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [accessTokenGuard],
    data: {allowedAccessToken: EAccessType.FAT,},
    children: [
      {
        path: 'admin-users',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_ADMINS},
        loadChildren: () =>
          import('./modules/admin-users/admin-users.module').then(
            (m) => m.AdminUsersModule
          ),
      },
      {
        path: 'admin-roles',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_ROLES},
        loadChildren: () =>
          import('./modules/admin-roles/admin-roles.module').then(
            (m) => m.AdminRolesModule
          ),
      },
       {
        path: 'interest-rate-bracket',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.VIEW_INTEREST_RATE_BRACKET},
        loadChildren: () =>
          import('./modules/interest-rate-bracket/interest-rate-bracket.module').then(
            (m) => m.InterestRateBracketModule
          ),
      },
      {
        path: 'transaction-categories',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_TRANSACTION_CATEGORIES},
        loadChildren: () =>
          import('./modules/transaction-categories/transaction-categories.module').then(
            (m) => m.TransactionCategoriesModule
          ),
      },
      {
        path: 'prices',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.VIEW_PRICES},
        loadChildren: () =>
          import('./modules/prices/prices.module').then(
            (m) => m.PricesModule
          ),
      },
    ]

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {
}
